(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // Check if searchModal exists before calling close
      if (this.searchModal) {
        this.searchModal.close(false);
      } else {
        
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery-popup"] && !Shopify.designMode) return;
  try {
    
class VideoModal {
  constructor() {
    this.openTriggers = document.querySelectorAll('[data-modal-target]');
    this.closeButtons = document.querySelectorAll('.video-modal__close-button');
    this.modals = document.querySelectorAll('.video-modal');
    this._addEventListeners();
  }

  _addEventListeners() {
    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.openModal(trigger.dataset.modalTarget));
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.closeModal(button.closest('.video-modal')));
    });

    // Close modal by clicking on the background
    this.modals.forEach(modal => {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          this.closeModal(modal);
        }
      });
    });
  }

  openModal(modalId) {
    const modal = document.querySelector(modalId);
    if (!modal) return;
    
    const video = modal.querySelector('.video-modal__video');
    
    modal.style.display = 'flex'; // Set display before animation
    setTimeout(() => {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        if (video) video.play();
    }, 10);
  }

  closeModal(modal) {
    if (!modal) return;

    const video = modal.querySelector('.video-modal__video');
    if (video) {
        video.pause();
        video.currentTime = 0; // Optional: rewind video
    }
    
    modal.classList.remove('is-open');
    document.body.style.overflow = ''; // Restore scrolling
    
    // Wait for animation to finish before hiding
    setTimeout(() => {
       modal.style.display = 'none';
    }, 300); // Should match transition duration
  }
}

// Initialize when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new VideoModal();
});

  } catch(e) { console.error(e); }
})();
})();
